/**
 * Resource danh sách phiếu thu
 * ntduong2 26/4/2023
 */
export default {
  Title: 'Danh sách phiếu thu',
  DetailTitle: 'Phiếu thu tiền',
  AccountingObject: 'Người nộp',
  Name: 'Họ tên',
  Address: 'Địa chỉ',
  AccountBank: 'TKKB',
  AccountBankTitle: 'Tài khoản kho bạc',
  Description: 'Diễn giải',
  Include: 'Kèm theo',
  VoucherRef: 'CT tham chiếu',
  VoucherRefTitle: 'Chứng từ tham chiếu',
  RefDate: 'Ngày PT',
  RefDateTitle: 'Ngày phiếu thu',
  PostedDate: 'Ngày HT',
  PostedDateTitle: 'Ngày hạch toán',
  RefNo: 'Số PT',
  RefNoTitle: 'Số phiếu thu',
  ThirdRefNo: 'Số GBN',
  ThirdRefNoTitle: 'Số giấy báo nợ',
  Popup: {
    Title: 'Tùy chọn in',
    NotShowAgain: 'Không hiển thị lại',
    ShowReceiptEnoughMoney: 'Hiển thị đã nhận đủ số tiền trên Phiếu thu',
  },
};
